export interface BlogPost {
  slug: string;
  title: string;
  description: string;
  author: string;
  date: string;
  category: BlogCategory;
  tags: string[];
  readingTime: {
    text: string;
    minutes: number;
    time: number;
    words: number;
  };
  featured: boolean;
  image?: string;
  content: string;
}

export enum BlogCategory {
  FUNDAMENTALS = "Fundamentals",
  PRACTICAL_GUIDES = "Practical Guides",
  TOOLS = "Tools & Testing",
  BUSINESS = "Business",
  LEGAL = "Legal",
  FRAMEWORKS = "Frameworks"
}

export interface BlogMetadata {
  title: string;
  description: string;
  author: string;
  date: string;
  category: BlogCategory;
  tags: string[];
  featured?: boolean;
  image?: string;
}